export default __webpack_public_path__ + "static/media/u1.8e7e03c5.png";